.facet {
  border-bottom: 1px solid #ddd;
}

/* Section header — matches the terms facet headers. */
.header {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.title {
  flex: 1;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #222;
}

.toggleIcon {
  margin-left: 8px;
  font-size: 20px;
  line-height: 1;
  color: #555;
}

/* Expandable menu. */
.menu {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding: 0 16px;
  transition:
    max-height var(--ns-transition-duration) var(--ns-transition-easing),
    opacity var(--ns-transition-duration) var(--ns-transition-easing),
    padding var(--ns-transition-duration) var(--ns-transition-easing);
}

.facet.active .menu {
  max-height: var(--ns-facet-max-height);
  opacity: 1;
  padding: 0 16px 16px;
}

/* Min / max inputs above the slider. */
.inputs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.input {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 8px 10px;
  font-family: inherit;
  font-size: 13px;
  text-align: center;
  color: #222;
  background: #ececed;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
}

/* Inset the slider so the handles don't overflow the menu edges. */
.slider {
  padding: 0 12px;
}
